import React, {Component} from 'react'
import MultiSelect from '../../../MultiSelect'
import {FieldGroup, Field, Select, InputText, Icon, TemplateVariable} from 'bsui'
import SettingsGroup from '../../../struct/SettingsGroup'
import {observer} from 'mobx-react'
import Hint from '../../../struct/Hint'

import styles from './StatusesSettings.less'

const fields_dbs = [
    {
        title: 'Заказ передан в доставку',
        name: 'order_action_ship',
        hint: (<div>
            <div>Рекомендуется передавать заказ в доставку:</div>
            <div>для домашнего региона — не позднее начала дня даты доставки;</div>
            <div>при отправке в другой регион — не позднее 2 дней до даты доставки.</div>
        </div>)
    },
    {
        title: 'Заказ готов к выдаче',
        name: 'order_action_pickup'
    },
    {
        title: 'Заказ доставлен/выдан',
        name: 'order_action_complete'
    },
    {
        title: 'Заказ отменён',
        name: 'order_action_delete'
    }
]

const fields_fbs = [
    {
        title: 'Заказ готов к отправке',
        name: 'order_action_ship'
    },
    {
        title: 'Заказ передан в доставку',
        name: 'order_action_pickup_out',
        hint: 'Магазин отгрузил товар'
    },
    {
        title: 'Заказ отменён',
        name: 'order_action_delete'
    }
]

const fbs_actions = [
    'ship',
    'pickup_out',
    'delete'
]

export default class StatusesSettings extends Component {
    constructor(props) {
        super(props)
        const fields = this.updateCampaignStatuses()
        this.state = {
            fields: fields
        }
        this.statuses = props.statuses
        this.onMultiSelectChangeWrapper = this.onMultiSelectChangeWrapper.bind(this)
    }

    updateCampaignStatuses(){
        let fields = {}
        if (this.props.type === 'DBS') {
            fields_dbs.map(field => {
                this.props.campaign[field.name] = this.props.campaign[field.name] ? this.props.campaign[field.name] :
                    this.props.settings[field.name] ? this.props.settings[field.name] : []
                if(this.props.settings[field.name]) this.props.settings[field.name] = ""
                fields[field.name] = {
                    values:this.props.campaign[field.name]
                }
            })
        } else {
            const suffix = this.props.type.toLowerCase()
            fbs_actions.map( action => {
                let field = 'order_action_' + action
                let field_settings = 'order_action_' + suffix + '_' +action
                this.props.campaign[field] = this.props.campaign[field] ? this.props.campaign[field] :
                    this.props.settings[field_settings] ? this.props.settings[field_settings] : []
                if(this.props.settings[field_settings]) this.props.settings[field_settings] = ""
                fields[field] = {
                    values: this.props.campaign[field]
                }
            })
        }
        return fields
    }

    onMultiSelectChangeWrapper(e) {
        const {name, value} = e.target
        const currentFields = this.state.fields
        this.setState({
            fields: {
                ...currentFields,
                [name]: {
                    values: value.values
                }
            }
        })

        this.props.campaign[name] = value.values
    }

    updateFields(){
        const fields = this.updateCampaignStatuses()
        this.setState({
            fields: fields
        })
    }

    componentWillMount = () => {
        this.updateFields();
    }

    componentWillReceiveProps = () => {
        this.updateFields();
    }

    render() {
        const {type} = this.props
        const fields = type === 'DBS' ? fields_dbs : fields_fbs
        const title = type === 'DBS' ? '7. Сопоставление смены статусов заказов в Я.Маркет при действиях магазина' : '6. Сопоставление смены статусов заказов в Я.Маркет при действиях магазина'

        return (
            <div>
                <SettingsGroup title={title}>
                    <Hint  className={styles['hintHeader']}>{'При выполнении выбранных действий в магазине, в Яндекс.Маркет будет автоматически отправляться смена статуса заказа.'}</Hint>
	                  <table className="zebra">
		                  <thead>
		                    <tr>
			                    <th>
				                    Сменить статус в Я.Маркет на:
			                    </th>
			                    <th>
				                    При действиях в вашем магазине:
			                    </th>
		                    </tr>
		                  </thead>
		                  <tbody>
			                  {fields.map(field => {
				                  const {title, name, hint} = field
				                  const fieldState = this.state.fields[name]
				                  let label = title

				                  if (hint) {
					                  label = (
						                  <React.Fragment>
							                  {title}
							                  <span className={'shop-tooltip' + ' ' + styles['tooltip-wrapper']}>
								                  <i className="icon10 info"></i>
								                  <span>
									                  {hint}
								                  </span>
							                  </span>
						                  </React.Fragment>
					                  )
				                  }

				                  if (fieldState !== undefined) {
					                  return (
					                  	<tr key={name}>
							                  <td className={styles['status-label']}>
							                    {label}
							                  </td>
							                  <td className={styles['status-values']}>
								                  <MultiSelect
									                  name={name}
									                  options={this.statuses}
									                  value={fieldState}
									                  optionRenderer={(data) => (
										                  <div
											                  key={data.key}
											                  className={"VirtualizedSelectOption" + (data.optionIndex === data.focusedOptionIndex
												                  ? " VirtualizedSelectFocusedOption" : "")}
											                  style={data.style}
											                  onMouseOver={e => data.focusOption(data.option)}
											                  onClick={e => data.selectValue(data.option)}>
											                  {data.option.label}
										                  </div>
									                  )}
									                  valueRenderer={data => data.label}
									                  onChange={this.onMultiSelectChangeWrapper}
								                  />
							                  </td>
						                  </tr>)
				                  }
			                  })}
		                  </tbody>
	                  </table>
                </SettingsGroup>
            </div>
        )
    }
}